const speeds = { slow: 0.04, medium: 0.07, fast: 0.1 };
const blocks = [...document.querySelectorAll('[data-full-width-image-parallax]')]
    .filter(block => Object.hasOwn(speeds, block.dataset.fullWidthImageParallax));

if (blocks.length) {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const visible = new Set();
    let frame = null;

    function update() {
        frame = null;
        const viewportHeight = window.innerHeight;
        // Read geometry before writing styles to avoid repeated layout work.
        const offsets = [...visible].map(block => {
            const rect = block.querySelector('.fullWidthImageBlock-media').getBoundingClientRect();
            const progress = Math.max(-1, Math.min(1,
                (viewportHeight / 2 - rect.top - rect.height / 2) / ((viewportHeight + rect.height) / 2)));
            return [block, progress * rect.height * speeds[block.dataset.fullWidthImageParallax]];
        });
        offsets.forEach(([block, offset]) => {
            block.style.setProperty('--full-width-image-offset', `${offset}px`);
        });
    }

    function schedule() {
        if (!reducedMotion.matches && visible.size && frame === null) {
            frame = window.requestAnimationFrame(update);
        }
    }

    const observer = new IntersectionObserver(entries => {
        entries.forEach(({ target, isIntersecting }) => {
            if (isIntersecting) visible.add(target);
            else visible.delete(target);
        });
        schedule();
    });

    function configure() {
        blocks.forEach(block => {
            block.classList.toggle('fullWidthImageBlock--parallax', !reducedMotion.matches);
            block.style.removeProperty('--full-width-image-offset');
            // Reserve slightly more crop than the maximum movement for each speed.
            block.style.setProperty('--full-width-image-overscan',
                `${speeds[block.dataset.fullWidthImageParallax] * 110}%`);
        });
        if (reducedMotion.matches) {
            if (frame !== null) window.cancelAnimationFrame(frame);
            frame = null;
        } else schedule();
    }

    blocks.forEach(block => observer.observe(block));
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    reducedMotion.addEventListener('change', configure);
    configure();
}
